module.exports = __webpack_public_path__ + "img/customer_zght.69887c41.svg";